import React from 'react'
import { Descriptions } from 'antd'
import { Commission as CommissionData } from '../../../../services/api/companies'

const { Item } = Descriptions
type Props = {
  commission: CommissionData
}

export const Commission: React.FunctionComponent<Props> = ({ commission }) => {
  return (
    <Descriptions bordered column={2}>
      <Item label="Наценка">
        {commission.amount}
        {commission.type === 'relative' ? '%' : 'RUB'}
      </Item>
    </Descriptions>
  )
}
